 const WIDTH_OPTIONS: any[] = [
    { id: 150, name: '150px' },
    { id: 200, name: '200px' },
    { id: 250, name: '250px' },
    { id: 300, name: '300px' },
    { id: 350, name: '350px' },
    { id: 400, name: '400px' },
    { id: 450, name: '450px' },
    { id: 500, name: '500px' },
    { id: 550, name: '550px' },
    { id: 600, name: '600px' },
    { id: 650, name: '650px' },
    { id: 700, name: '700px' },
    { id: 750, name: '750px' },
    { id: 800, name: '800px' },
    { id: 1000, name: '1000px'},
    { id: 1200, name: '1200px'}
];

export default class WorkspaceOptionValues {

    static readonly WIDTH_OPTIONS = WIDTH_OPTIONS;
}